import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './GeneralInfoForm.css';

const BloodGroupForm = ({ bloodGroupId, initialData, onSuccess }) => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const [bloodGroupName, setBloodGroupName] = useState('');
     const [loading, setLoading] = useState(false);
     const [error, setError] = useState('');
     const navigate = useNavigate();

     // ✅ Fill form if initialData is provided (edit mode)
     useEffect(() => {
          if (initialData && initialData.bloodgroup) {
               setBloodGroupName(initialData.bloodgroup);
          }
     }, [initialData]);

     const handleSubmit = async (e) => {
          e.preventDefault();

          if (!bloodGroupName.trim()) {
               setError('Blood Group name is required');
               return;
          }

          setLoading(true);
          setError('');

          try {
               let url = '';
               let method = 'POST';
               let body = {};

               if (bloodGroupId) {
                    // ✅ Edit mode
                    url = `${baseUrl}/updateBloodGroupById/${bloodGroupId}`;
                    body = { bloodGroup: bloodGroupName };
               } else {
                    // ✅ Create mode
                    url = `${baseUrl}/createBloodGroup`;
                    body = { bloodGroup: bloodGroupName };
               }

               const response = await fetch(url, {
                    method,
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body),
               });

               const data = await response.json();

               if (data.status) {
                    alert(bloodGroupId ? 'Blood Group updated successfully' : 'Blood Group created successfully');
                    if (onSuccess) onSuccess();
                    navigate('/bloodgroup');
               } else {
                    setError(data.message || `Failed to ${bloodGroupId ? 'update' : 'create'} BloodGroup`);
               }
          } catch (err) {
               setError('Error connecting to server');
          } finally {
               setLoading(false);
          }
     };

     return (
          <form className="general-info-form" onSubmit={handleSubmit}>

               <div className="form-grid">
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control"
                              id="bloodGroupName"
                              placeholder=" "
                              autoComplete="off"
                              value={bloodGroupName}
                              onChange={(e) => setBloodGroupName(e.target.value)}
                              disabled={loading}
                         />
                         <label htmlFor="bloodGroupName">Blood Group Name</label>
                    </div>
               </div>
               {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
               <button
                    type="submit"
                    className="btn btn-primary"
                    style={{ marginTop: '15px' }}
                    disabled={loading}
               >
                    {loading ? 'Saving...' : 'Save'}
               </button>
          </form>
     );
};

export default BloodGroupForm;
